import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import IncidentReportsList from "../pages/Phase-05/IncidentReport/IncidentReportList";
import {
  fetchIncidentReports,
  deleteIncidentReport,
} from "../store/slices/incidentReportsSlice";

const IncidentReports = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const canManage = true;
  const canCreate = true;
  const canEdit = true;
  const canDelete = true;

  const { incidentReports, isLoading, error } = useSelector(
    (state) => state.incidentReports
  );

  useEffect(() => {
    dispatch(fetchIncidentReports());
  }, [dispatch]);

  const handleAdd = () => navigate("/phase05/incident-report/add");
  const handleEdit = (id) => navigate(`/phase05/incident-report/edit/${id}`);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This Incident Report will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      await dispatch(deleteIncidentReport(id));
      Swal.fire("Deleted!", "Record has been removed successfully.", "success");
    }
  };

  if (!canManage)
    return (
      <Navigate
        to="/dashboard"
        state={{
          error: "You do not have permission to manage Incident Reports.",
        }}
        replace
      />
    );

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />

        {error && (
          <div
            className="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            <strong>Error:</strong> {error}
          </div>
        )}

        <div className="card">
          <div className="card-body">
            {isLoading ? (
              <div className="d-flex justify-content-center py-5">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <IncidentReportsList
                records={incidentReports || []}
                onAdd={canCreate ? handleAdd : null}
                onEdit={canEdit ? handleEdit : null}
                onDelete={canDelete ? handleDelete : null}
              />
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default IncidentReports;
